type Props = {
  reference: string | undefined;
  title: string | undefined;
};

export const ConfirmationBanner: React.FunctionComponent<Props> = (
  props: Props,
) => {
  return (
    <section className="bg-status-success section-vertical-padding section-horizontal-padding -section-horizontal-margin flex flex-col gap-y-7 py-8 text-white">
      <section className="text-h1">
        {props.title ? props.title : 'Your report has been submitted'}
      </section>
      <section className="flex flex-col gap-y-3">
        {props.reference && (
          <>
            <div className="text-bodyXl">Your reference number</div>
            <div className="text-h2">{props.reference}</div>
          </>
        )}
      </section>
    </section>
  );
};
